import React from "react";
import {Link} from 'react-router-dom';
import img from '../images/head.jpg';

const Head = () =>{
    return(
        
					<div className="container">
						<div className="row">
						{/* <div className="col-12 col-md-3 header">
							<img style={{height:"100px", width:"60%",marginBottom:"0px"}} src={img} ></img>
								
							</div> */}

                              <div className="col-12 col-md-3 header1">
								<img style={{height:"150px", width:"100%"}} src={img} ></img>

								</div>
								
							<div  className="col-12 col-md-6 header ">
							
								<h1 className="logo" style={{fontFamily:"cursive"}}><a href="/">InfoMine</a></h1>
								<p className="tagline" >Your Learning Destination</p>
							</div>
							{/* <div className="col-12 col-md-3 header2">
								<img style={{height:"150px", width:"100%"}} src={img} ></img>

								</div> */}
						</div>
					</div>
				
    )
}

export default Head;